var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgM(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "292.46 334.92 601.1 390.28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 292.46,
    y1: 530.07,
    x2: 893.57,
    y2: 530.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#39b54a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#27aae1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#662d91"
  })), /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M540.19,633.08q13.07-4.36,21.16-11.2,16.81-57.26,28.63-94t18.05-61h3.11q1.87,36.72,2.49,90.87,1.24,54.15,5,122,1.24,23.65,17.43,31.74t39.83,8.09q18.05,0,29.25-3.11a74,74,0,0,0,22.41-8.71q-0.62-14.94-2.49-42.32-1.87-28-5-61-2.49-33.61-5.6-69.71t-6.22-68.47q-3.11-32.37-6.22-57.88-2.49-26.14-5-38.59-3.11-16.81-22.41-25.52-19.29-9.34-49.79-9.34a136,136,0,0,0-33,3.73q-14.32,3.11-23.65,8.09-12.45,33-27.39,82.16-14.94,48.55-29.88,100.83h-3.11q-5-16.18-11.2-36.1-6.22-20.54-13.07-41.08-6.22-20.54-13.07-39.83-6.22-19.29-11.83-34.23-8.71-23-27.39-33-18.67-10.58-51.66-10.58-30.5,0-47.3,9.34t-21.78,17.43L292.46,679.14q0,23,14.94,31.74,15.56,8.71,42.95,8.71a139.42,139.42,0,0,0,26.14-2.49,99.66,99.66,0,0,0,21.16-5q1.87-35.48,2.49-64.73,1.24-29.25,1.24-57.88Q402,560.88,402.63,531q1.24-30.5,3.11-67.22h3.11q6.22,25.52,17.43,59.75,11.2,33.61,28.63,88.38,4.36,13.69,18.67,19.29,14.94,5.6,37.35,5.6Q527.74,636.82,540.19,633.08ZM789,620.64q-16.18,17.43-16.18,43.57T789,707.77q16.18,17.43,44.19,17.43t44.19-17.43q16.18-17.43,16.18-43.57t-16.18-43.57q-16.18-17.43-44.19-17.43T789,620.64Zm79.66,4.28-13.28-9.3-59.5,85,13.28,9.3Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgM);
export default __webpack_public_path__ + "static/media/M.faf2e02a64a71e76113aa7e50374ac0a.svg";
export { ForwardRef as ReactComponent };